<div id="homepage-top">
    <div id="quick-quote-container">
        <pixie-hkdl-quick-quote
            class="hkdl-quick-quote"
            *ngIf="siteId==='hkdl' && utilsConfig && hkdlResourceBundle"
            [config]="utilsConfig"
            tabindex="0"
            [resourceBundle]="hkdlResourceBundle">
        </pixie-hkdl-quick-quote>
    </div>
    <app-non-fast-hero class="{{ 'non-fast ' + siteId }}"></app-non-fast-hero>
    <a
        *ngIf="parkHoursBundle"
        class="park-hours-link"
        [href]="parkHoursBundle.href | absTrimmer:false:true"
    >
        <div class="park-hours">
            <div class="park-hours-icons"><div class="di di-norgie-closed"></div></div>
            <div class="park-hours-label"><span class="" [innerHtml]="parkHoursBundle.title | safeHtml"></span></div>
        </div>
    </a>
</div>

<pixie-stories appDeepLink></pixie-stories>
